import React from "react";
import chipRed from "../assets/image/chip_red.png";
import chipBlue from "../assets/image/chip_blue.png";
import chipGreen from "../assets/image/chip_green.png";
import chipPurple from "../assets/image/chip_purple.png";
import chipGold from "../assets/image/chip_gold.png";

function convertToShortForm(number) {
  if (number >= 1000) {
    const suffixes = ["", "k", "M", "B", "T"];
    const magnitude = Math.floor(Math.log10(number) / 3);
    const shortNumber = (number / Math.pow(1000, magnitude)).toFixed(0);
    return shortNumber + suffixes[magnitude];
  }
  return number?.toString();
}

export function chipImageForAmount(number) {
  if (number === 100) return chipRed;
  if (number === 1000) return chipBlue;
  if (number === 10000) return chipGreen;
  if (number === 50000) return chipPurple;
  if (number === 100000) return chipGold;
  return chipBlue;
}

export default function CoinButton(props) {
  const { funcClick, selectedClass, disabledClass, number } = props;

  const shortForm = convertToShortForm(number);
  const chipImage = chipImageForAmount(number);

  return (
    <button
      className={`${disabledClass + ""} ${selectedClass} dimond-box`}
      style={{
        color: "#ffff",
        fontWeight: "700",
      }}
      onClick={funcClick}
    >
      <div className="chip-wrapper">
        <img src={chipImage} alt="" />
        <h6>{shortForm}</h6>
      </div>
    </button>
  );
}
